module.exports = __webpack_public_path__ + "media/entities/1000-41e228cc.png";